import { ModelBase } from 'store/model-base';

export class PendingLine extends ModelBase {
    public static storeName: string = 'pendingLine';

    public lineId: string;
    public category: string;
    public mdn: string;
    public imei: string;
    public transferPairedLines: boolean;
    public transferPairedLineIds: string[];
    public ceasePairedLineIds: string[];
    public status: string;
    public cancelReason: string;
    public insurancePlan: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        return super.create<T>(data);
    }
}
